// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"ee7294b966cf044fb8d8","655":"e3aaa74dceb06a009f5a"}[chunkId] + ".js";
};